import { render, staticRenderFns } from "./OwnerLoad.vue?vue&type=template&id=15c352f2&"
import script from "./OwnerLoad.vue?vue&type=script&lang=js&"
export * from "./OwnerLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports